import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ApplicationDataService } from '../../../../core/services/application-data.service';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-appeal-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatInputModule, MatButtonModule, TranslateModule, MatFormFieldModule, MatDialogModule],
  templateUrl: './appeal-dialog.component.html',
  styleUrl: './appeal-dialog.component.css'
})
export class AppealDialogComponent {
  form: FormGroup;
  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<AppealDialogComponent>,
      public dialog: MatDialog, private formBuilder: FormBuilder,
      private appDataService: ApplicationDataService,
      private authService: AuthenticationService
    ) {
  }
   ngOnInit() {
    this.form = this.formBuilder.group({
      complaintId: [this.data?.complaintId, [Validators.required]],
      segmentId: [this.authService.getUserSegment()],
      comment: [''],
    });
  }

  close(submitted: boolean = false) {
    this.dialogRef.close({ submitted });
  }

  appeal() {

    if (this.form.invalid) {
      return;
    }

    this.appDataService.appealComplaint(this.form.value).subscribe(res => {
      this.close(true);
    })
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
}
